module.exports = __webpack_public_path__ + "img/coal_turkish1.3f5088d0.png";